require('../../node_modules/uikit/dist/js/uikit.min.js');
import UIkit from 'uikit';

$(document).on('click', ".mobile-menu-icon", function ( event ) {
    $('.mobile-menu-icon label').removeClass('return');
    $('.mobile-menu-overlay').addClass('menu-fixed');
    $('html').css('overflow-y','hidden');

    if($(this).find('input').is(':checked')) {
        $('.mobile-menu-block').addClass('open');
        $('body').addClass('filter-open');
    } else {
        $('.mobile-menu-block').removeClass('open');
        $('body').removeClass('filter-open');
    }
});

$(document).on('click', ".mobile-menu-overlay.menu-fixed", function ( event ) {
    $('.mobile-menu-overlay').removeClass('menu-fixed');
    $('html').css('overflow-y','visible');
    $('.mobile-menu-block').removeClass('open');

    if($('.mobile-menu-icon').find('input').is(':checked')) {
        $('.mobile-menu-icon label').addClass('return');
        $('.mobile-menu-icon input').prop('checked', false);
        $('body').removeClass('filter-open');
    } else {
        $('.mobile-menu-icon label').removeClass('return');
        $('.mobile-menu-icon input').prop('checked', true);
        $('body').removeClass('filter-open');
    }
});

$(document).on('click', ".mobile-menu-block.open .close-menu", function ( event ) {
    $('.mobile-menu-overlay').removeClass('menu-fixed');
    $('html').css('overflow-y','visible');

    if($('.mobile-menu-icon').find('input').is(':checked')) {
        $('.mobile-menu-icon label').addClass('return');
        $('.mobile-menu-icon input').prop('checked', false);
        $('body').removeClass('filter-open');
    } else {
        $('.mobile-menu-icon label').removeClass('return');
        $('.mobile-menu-icon input').prop('checked', true);
        $('body').removeClass('filter-open');
    }
});





UIkit.scrollspy('.scroll-fade-fast', {cls:'uk-animation-fade', repeat: true, delay: 100});
UIkit.scrollspy('.scroll-fade-slow', {cls:'uk-animation-fade', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-fade-1', {cls:'uk-animation-fade', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-fade-2', {cls:'uk-animation-fade', repeat: true, delay: 400});
UIkit.scrollspy('.scroll-fade-3', {cls:'uk-animation-fade', repeat: true, delay: 600});
UIkit.scrollspy('.scroll-left-small', {cls:'uk-animation-slide-left-small', repeat: true, delay: 100});
UIkit.scrollspy('.scroll-right-small', {cls:'uk-animation-slide-right-small', repeat: true, delay: 100});
UIkit.scrollspy('.scroll-left-medium', {cls:'uk-animation-slide-left-medium', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-right-medium', {cls:'uk-animation-slide-right-medium', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-left', {cls:'uk-animation-slide-left', repeat: true, delay: 250});
UIkit.scrollspy('.scroll-right', {cls:'uk-animation-slide-right', repeat: true, delay: 250});
UIkit.scrollspy('.scroll-left-large', {cls:'uk-animation-slide-left', repeat: true, delay: 350});
UIkit.scrollspy('.scroll-right-large', {cls:'uk-animation-slide-right', repeat: true, delay: 350});


UIkit.scrollspy('.scroll-fade', {cls:'uk-animation-fade', delay: 300});
UIkit.scrollspy('.scroll-fade-150', {cls:'uk-animation-fade', delay: 150});
UIkit.scrollspy('.scroll-fade-200', {cls:'uk-animation-fade', delay: 200});
UIkit.scrollspy('.scroll-fade-400', {cls:'uk-animation-fade', delay: 400});
UIkit.scrollspy('.scroll-fade-600', {cls:'uk-animation-fade', delay: 600});
UIkit.scrollspy('.scroll-fade-300', {cls:'uk-animation-fade', delay: 300});
UIkit.scrollspy('.scroll-fade-600', {cls:'uk-animation-fade', delay: 600});
UIkit.scrollspy('.scroll-fade-700', {cls:'uk-animation-fade', delay: 700});
UIkit.scrollspy('.scroll-fade-800', {cls:'uk-animation-fade', delay: 800});
UIkit.scrollspy('.scroll-fade-900', {cls:'uk-animation-fade', delay: 900});



UIkit.scrollspy('.scroll-left-small-norepeat', {cls:'uk-animation-slide-left-small', delay: 100});
UIkit.scrollspy('.scroll-left-medium-norepeat', {cls:'uk-animation-slide-left-medium', delay: 200});

UIkit.scrollspy('.scroll-right-small-norepeat', {cls:'uk-animation-slide-right-small', delay: 100});
UIkit.scrollspy('.scroll-right-medium-norepeat', {cls:'uk-animation-slide-right-medium', delay: 200});
